import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ExpTreeTable from '../ExpTreeTable';
import TreeTableButtons from '../TreeTableButtons';
import Section from '../Section';

class ExpTreeTableWithButtons extends React.Component {
  constructor(props) {
    super(props);
    const { treeTableButtonsProps, defaultExpLevel } = this.props;
    const allButtons = this.getInitialButtonState(treeTableButtonsProps.buttons);
    this.state = {
      allButtons,
      expandLevel: defaultExpLevel
    };
  }

  getInitialButtonState = (buttons) => {
    const { defaultExpLevel } = this.props;
    const buttonState = [];
    buttons.forEach((button) => {
      buttonState[button.accessor] = defaultExpLevel === button.expLevel ? '' : 'secondary';
    });
    return buttonState;
  }

  expandRows = (e, { level, accessor }) => {
    const { allButtons } = this.state;
    // eslint-disable-next-line no-return-assign
    Object.keys(allButtons).forEach((button) => {
      allButtons[button] = accessor === button ? '' : 'secondary';
    });
    this.setState({ allButtons, expandLevel: level });
  };

  render() {
    const { expTreeTableProps, treeTableButtonsProps } = this.props;
    const { expandLevel, allButtons } = this.state;
    const allExpTreeTableProps = {
      ...expTreeTableProps,
      expandLevel
    };
    const { buttons, ...restButtonsProps } = treeTableButtonsProps;
    const buttonsProps = [];
    buttons.forEach((button) => {
      buttonsProps.push({
        text: button.text,
        accessor: button.accessor,
        usage: allButtons[button.accessor],
        info: button.info,
        onClick: (e) => this.expandRows(e, { level: button.expLevel, accessor: button.accessor })
      });
    });
    const allTreeTableButtonsProps = {
      buttons: buttonsProps,
      ...restButtonsProps
    };
    return(
      <Fragment>
        <TreeTableButtons {...allTreeTableButtonsProps} />
        <Section>
          <ExpTreeTable {...allExpTreeTableProps} />
        </Section>
      </Fragment>
    );
  }
}

ExpTreeTableWithButtons.propTypes = {
  defaultExpLevel: PropTypes.number,
  expTreeTableProps: PropTypes.shape({
    /** The table data, headers, and total to be rendered by ExpTreeTable. */
    table: PropTypes.object,
    /** The table data object. */
    data: PropTypes.array,
    /** An array of fields (accessors) in the dataset that you want to pivot on
        The ordering of the values in the array will match the pivot order */
    pivotBy: PropTypes.array,
    /** An array of fields (accessors) that should be displayed and aggregrated at the pivot levels.
        Any values passed in the array will be displayed in the pivot rows of ExpTreeTable */
    aggregateBy: PropTypes.array,
    /** The value you want displayed as a nested subcomponent of a row with expand/hide functionality. */
    subComponent: PropTypes.string,
    /** The index of the column where you want to insert the subcomponent view and hide details button. */
    subIndex: PropTypes.number,
    /** Max column width */
    maxColWidth: PropTypes.number
  }),
  treeTableButtonsProps: PropTypes.shape({
    /** The hidden title for a11y */
    a11yTitle: PropTypes.string.isRequired,
    /** The header level of the a11y header, default level 4. */
    headerLevel: PropTypes.number,
    /** An array of button that control the expand/collapse of tree table rows */
    buttons: PropTypes.arrayOf(PropTypes.shape({
      /** The button information */
      info: PropTypes.string,
      /** The text displayed on the buttons */
      text: PropTypes.string,
      /** The expand level the button should set on the tree table */
      expLevel: PropTypes.number,
      /** The data access of the field the button controls expansion of */
      accessor: PropTypes.string
    }))
  })
};

export default ExpTreeTableWithButtons;
